import { Button } from "@material-ui/core";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { Input, Label } from "reactstrap";
import { ApiGet } from "../../../helpers/API/ApiData";
import "./CredentialManagement.scss";

function AddParkingOwnerDetails(props) {
  const [inputType, setInputType] = useState(false);

  const {
    inputValue,
    handleChange,
    errors,
    formType,
    handleAddNews,
    buttonLoading,
    setUploadImage,
    loading,
    handleOnClose,
    setInputValue,

    setVattenfallChecked,
    vattenfallChecked,
    selectedVattenfallPartner,
    setSelectedVattenfallPartner,
  } = props;
  const [locationLoader, setLocationLoader] = useState(false);
  const [locationNames, setLocationNames] = useState([]);
  useEffect(() => {
    const handleGetLocation = async () => {
      setLocationLoader(true);
      try {
        const response = await ApiGet(
          `dahualocation/getAllLocations?limit=${50}&page=${1}`
        );
        const data = response?.data?.payload;
        if (data && Array.isArray(data)) {
          const optionData = data.map((item) => ({
            value: item?._id,
            label: item?.name,
          }));

          setLocationNames(optionData);
          setLocationLoader(false);
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          setLocationNames([]);
          setLocationLoader(false);
        } else {
          setLocationLoader(false);
          toast.error("Etwas ist schief gelaufen");
        }
      }
    };

    handleGetLocation();

    // handleGetPostalCode();
  }, []);

  const handleImagesss = (event) => {
    const file = event.target.files[0];
    setInputValue({ ...inputValue, profileImage: file });
    setUploadImage(URL.createObjectURL(file));
  };

  useEffect(() => {
    if (formType == "update") {
      const newPartnerDta = inputValue?.vattenfallPatners?.map((item) => item);
      setSelectedVattenfallPartner(newPartnerDta);
    }
  }, []);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      maxHeight: "100px",
      width: "200px",
      minHeight: "unset",
      overflow: "auto",
    }),
  };

  const handleOnNewChange = (selectedPatner) => {
    setSelectedVattenfallPartner(selectedPatner);
    if (selectedPatner && selectedPatner.length > 0) {
      setInputValue({ ...inputValue, vattenfallPatners: selectedPatner });
    } else {
      setInputValue({ ...inputValue, vattenfallPatners: [] });
    }
  };

  const bindInput = (value) => {
    var regex = new RegExp("^[^0-9]*$");
    var key = String.fromCharCode(
      !value.charCode ? value.which : value.charCode
    );
    if (regex.test(key)) {
      value.preventDefault();
      return false;
    }
  };

  return (
    <div className="modal-content new-model-conent-sye">
      <Modal.Header
        className="justify-content-start d-flex align-items-center"
        closeButton
      >
        <Modal.Title style={{ color: "#D7365A" }}>
          {formType == "add"
            ? "Parkplatzbesitzer hinzufügen"
            : "Parkplatzbesitzer  aktualisieren"}{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="name">
              Benutzername <span className="text-danger">*</span>
            </Label>
            <Input
              placeholder="Benutzername"
              name="name"
              value={inputValue?.name}
              onChange={(event) => handleChange(event, "input")}
              invalid={errors?.name && "true"}
            />
            <span className="errors">{errors?.name}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Vorname">
              Vorname <span className="text-danger">*</span>
            </Label>
            <Input
              placeholder="Vorname"
              name="vorname"
              value={inputValue?.vorname}
              onChange={(event) => handleChange(event, "input")}
              invalid={errors?.vorname && "true"}
            />
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Nachname">
              Nachname
            </Label>
            <Input
              placeholder="Nachname"
              name="nachname"
              value={inputValue?.nachname}
              onChange={(event) => handleChange(event, "input")}
              invalid={errors?.nachname && "true"}
            />
          </div>
        </div>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="name">
              E-mail <span className="text-danger">*</span>
            </Label>
            <Input
              type="email"
              placeholder="E-mail"
              name="email"
              value={inputValue?.email}
              disabled={formType !== "add" ? true : false}
              style={{ cursor: formType !== "add" ? "not-allowed" : "" }}
              onChange={(event) => handleChange(event, "input")}
              invalid={errors?.email && "true"}
            />
            <span className="errors">{errors?.email}</span>
          </div>

          <div className="col-4 col-md-4">
            <Label className="form-label" for="name">
              {formType == "add" ? "Passwort" : "Neues Kennwort"}
              {formType == "add" && <span className="text-danger">*</span>}
            </Label>
            <div className="eyeIconContainer">
              <Input
                type={!inputType ? "password" : "text"}
                placeholder="Passwort"
                name="password"
                value={inputValue?.password}
                onChange={(event) => handleChange(event, "input")}
                invalid={errors?.password && "true"}
              />
              <i
                onClick={() => setInputType(!inputType)}
                className={
                  inputType ? "eyeIcon fa fa-eye-slash" : "eyeIcon fa fa-eye"
                }
                aria-hidden="true"
              ></i>
            </div>
            {formType == "add" && (
              <span className="errors">{errors?.password}</span>
            )}
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="name">
              Telefon
            </Label>
            <Input
              type="text"
              placeholder="Telefon"
              name="phone"
              onKeyPress={bindInput}
              value={inputValue?.phone}
              onChange={(event) => handleChange(event, "input")}
              invalid={errors?.phone && "true"}
            />
            <span className="errors">{errors?.phone}</span>
          </div>
        </div>

        <div className="row pb-3">
          <div
            className="col-4 col-md-4"
            style={{ display: "flex", alignItems: "center" }}
          >
            <input
              type="checkbox"
              style={{ marginBottom: "10px" }}
              checked={vattenfallChecked}
              onChange={(e) => setVattenfallChecked(e.target.checked)}
            />{" "}
            <Label className="form-label" style={{ paddingLeft: "10px" }}>
              Unzer Parkplatzbesitzer
            </Label>
          </div>

          {vattenfallChecked && (
            <div className="col-4 col-md-4">
              <Label className="form-label" for="name">
                Unzer Parkplatzbesitzer
              </Label>
              <div>
                <div>
                  <Select
                    options={
                      locationLoader
                        ? [{ value: "Loading...", name: "Loading..." }]
                        : locationNames
                    }
                    className="dropdown-align "
                    value={selectedVattenfallPartner}
                    onChange={handleOnNewChange}
                    isMulti
                    maxHeight={"100px"}
                    styles={customStyles}
                    defaultValue={selectedVattenfallPartner}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="activebutton h-40px"
          onClick={handleOnClose}
          style={{ marginRight: "15px" }}
        >
          Abbrechen
        </Button>
        <Button
          disabled={loading}
          className="addbutton"
          onClick={handleAddNews}
        >
          <span>{formType == "add" ? " Speichern" : "aktualisieren"}</span>
          {(buttonLoading || loading) && (
            <div class="h-20px spinner-border text-light w-20px ml-2"></div>
          )}
        </Button>
      </Modal.Footer>
    </div>
  );
}

export default AddParkingOwnerDetails;
